import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from '@app/account/login/index.module.less';
import LoginForm from '@base/account/login/LoginForm';
import RegisterForm from '@base/account/login/RegisterForm';
import { trackPageView } from 'base/utils/tracker';
import { useTrans } from 'base/utils/i18n';

const PageLogin: Globals.NextPage<void> = () => {
    const { t } = useTrans();

    useEffect(() => {
        trackPageView();
    }, []);

    return (
        <div className={cn('flex', styles.wrapper)}>
            <div className={styles.col}>
                <h2 className="text-center">{t('web_login_sign_in_title')}</h2>
                <LoginForm/>
            </div>
            <div className={styles.col}>
                <h2 className="text-center">{t('web_register_title')}</h2>
                <RegisterForm />
            </div>
        </div>
    )
};

PageLogin.pageConf = {
    pageCode: 'login',
};

export default PageLogin;
